import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import { Badge, Checkbox, IconButton, ListItemText, Menu, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LayersOutlinedIcon from "@material-ui/icons/LayersOutlined";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 4,
    paddingBottom: 4,
  },
  menuItem: {
    minHeight: 34,
    paddingTop: 2,
    paddingBottom: 2,
  },
  queueButton: {
    height: 34,
    width: 34,
    border: `1px solid ${theme.mode === "light" ? "#e2e8f0" : "rgba(255,255,255,0.12)"}`,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "rgba(255,255,255,0.05)",
    color: theme.mode === "light" ? "#64748b" : "#cbd5e1",
    borderRadius: 10,
    padding: 0,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      backgroundColor: theme.mode === "light" ? `${theme.palette.primary.main}10` : "rgba(255,255,255,0.08)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      marginRight: 6,
    },
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      marginRight: 6,
    },
  },
  activeButton: {
    borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    backgroundColor: theme.mode === "light" ? `${theme.palette.primary.main}12` : "rgba(255,255,255,0.1)",
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  icon: {
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeDot: {
    height: 8,
    minWidth: 8,
    borderRadius: 999,
    padding: 0,
    right: 5,
    top: 5,
    backgroundColor: theme.palette.primary.main,
  },
  menuPaper: {
    borderRadius: 10,
    minWidth: 220,
    maxWidth: "calc(100vw - 24px)",
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isOpen = Boolean(anchorEl);
  const allQueueIds = (userQueues || []).map((queue) => queue.id);
  const hasQueueFilter =
    selectedQueueIds.length !== allQueueIds.length ||
    selectedQueueIds.some((id) => !allQueueIds.includes(id));

  const handleToggleQueue = (queueId) => {
    const isSelected = selectedQueueIds.indexOf(queueId) > -1;
    const nextValues = isSelected
      ? selectedQueueIds.filter((id) => id !== queueId)
      : [...selectedQueueIds, queueId];

    onChange(nextValues);
  };

  return (
    <>
      <Tooltip title="Filtrar por fila">
        <Badge
          color="primary"
          variant="dot"
          invisible={!hasQueueFilter}
          classes={{ badge: classes.activeDot }}
        >
          <IconButton
            className={`${classes.queueButton} ${hasQueueFilter ? classes.activeButton : ""}`}
            onClick={(event) => setAnchorEl(event.currentTarget)}
            aria-label="Filtrar por fila"
            title="Filtrar por fila"
          >
            <LayersOutlinedIcon className={classes.icon} />
          </IconButton>
        </Badge>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        classes={{ paper: classes.menuPaper }}
        MenuListProps={{ className: classes.menuListItem }}
      >
        {userQueues?.length > 0 &&
          userQueues.map((queue) => (
            <MenuItem
              dense
              key={queue.id}
              value={queue.id}
              className={classes.menuItem}
              onClick={() => handleToggleQueue(queue.id)}
            >
              <Checkbox
                style={{ color: queue.color }}
                size="small"
                color="primary"
                checked={selectedQueueIds.indexOf(queue.id) > -1}
              />
              <ListItemText
                primary={queue.name}
                classes={{ primary: classes.listItemText }}
              />
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default TicketsQueueSelect;
